import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ICombustivel } from '@app/modules/combustivel/model/combustivel.model';
import { CombustivelService } from '@app/modules/combustivel/services/combustivel.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';

@Component({
  templateUrl: './fast-combustivel.component.html',
  styleUrls: ['./fast-combustivel.component.scss'],
  providers: [CombustivelService]
})
export class FastCombustivelComponent implements OnInit {
  @ViewChild('fastCombustivel') fastCombustivel: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    nome: {
      duplicate: 'Já existe um combustível cadastrado com esse nome!',
      required: 'Nome é obrigatório',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    valor: {
      required: 'Valor é obrigatório',
      min: 'Valor deve ser maior que 0',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastCombustivelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICombustivel,
    protected fb: UntypedFormBuilder,
    public entityService: CombustivelService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastCombustivel.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      valor: [
        0,
        [Validators.required, CustomValidators.validateCurrencyValues(17, 4)]
      ],
      nome: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      let entity = { domain_id: this.tokenService.getDomain().id, ...rest };
      entity.valor = Utils.replaceCommaToDot(entity.valor);
      entity = Utils.trimAttributes(entity);
      this.entityService.insert(entity).subscribe(
        servico => {
          if (servico) {
            this.matSnackBar.open(
              `Novo combustível cadastrado com sucesso.`,
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
            this.dialogRef.close(servico);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'nome',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
